import React from "react";
import { Box, Typography } from "@mui/material";
import PageNotFoundImage from 'assets/images/404.png';

export const PageNotFound = () => {
    return (
        <Box sx={{ height: '70vh', py: 8, textAlign: 'center' }}>
            <img src={PageNotFoundImage} alt="Page Not Found" />
            <Typography variant="h6" component="h1">Sorry, Page Not Found</Typography>
            <Typography variant="subtitle1" >The page you are looking for cannot be found. It's possible that the content you're searching for has been moved, <br /> deleted, or never existed in the first place.</Typography>
        </Box>
    )
}